import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  }, {
    path: '/index',
    name: 'index',
    component: () => import('../views/index'),
    meta:{
      title: '三益友'
    },
    children:[{
      path: '/home',
      name: 'home',
      component: () => import('../views/index/index'),
      meta:{
        title: '三益友'
      },
    },{
      path: '/aboutUs',
      name: 'aboutUs',
      component: () => import('../views/aboutUs/index'),
      meta:{
        title: '关于我们'
      },
    },{
      path: '/solutionPay',
      name: 'solutionPay',
      component: () => import('../views/solution/pay'),
      meta:{
        title: '金融支付'
      },
    },{
      path: '/internet',
      name: 'internet',
      component: () => import('../views/solution/internet'),
      meta:{
        title: '互联网'
      },
    },{
      path: '/outbound',
      name: 'outbound',
      component: () => import('../views/solution/outbound'),
      meta:{
        title: '跨境/进出口'
      },
    },{
      path: '/new',
      name: 'new',
      component: () => import('../views/new/index'),
      meta:{
        title: '新闻资讯'
      },
    },{
      path: '/joinUs',
      name: 'joinUs',
      component: () => import('../views/joinUs/index'),
      meta:{
        title: '加入我们'
      },
    },{
      path: '/contactUs',
      name: 'contactUs',
      component: () => import('../views/contactUs/index'),
      meta:{
        title: '联系我们'
      },
    }]
  },{
    path: '/newDetail',
    name: 'newDetail',
    component: () => import('../views/new/detail'),
    meta:{
      title: '新闻资讯'
    },
  },
]

const router = new VueRouter({
  // mode: 'history',
  // base: '/web/',
  base: process.env.BASE_URL,
  routes
})

export default router
